import { Box, Loader } from '@wix/design-system';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { FeaturesNamespace } from './FeaturesNamespace';
import { getVisibleNamespaces } from './getVisibleNamespaces';
import { LegacyPlanFeatures } from './LegacyPlanFeatures';
export const PlanFeatures = _ref => {
  let {
    productId,
    t,
    Trans,
    paymentCycle,
    isDetailedView,
    onError,
    dataHook
  } = _ref;
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: featuresGridData,
    isLoading,
    isError
  } = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetFeaturesGrid({
    productIds: [productId],
    ...p3Context
  }, !!productId);
  React.useEffect(() => {
    if (isError) {
      onError == null || onError();
    }
  }, [isError, onError]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      height: "100%"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  if (!isDetailedView) {
    return /*#__PURE__*/React.createElement(LegacyPlanFeatures, {
      namespaces: featuresGridData == null ? void 0 : featuresGridData.namespaces,
      productId: productId,
      paymentCycle: paymentCycle,
      t: t,
      Trans: Trans,
      dataHook: dataHook
    });
  }
  const visibleNamespaces = getVisibleNamespaces(featuresGridData == null ? void 0 : featuresGridData.namespaces, productId, paymentCycle);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    dataHook: dataHook
  }, visibleNamespaces.map(ns => /*#__PURE__*/React.createElement(FeaturesNamespace, {
    key: ns.id,
    namespace: ns,
    productId: productId,
    t: t,
    Trans: Trans
  })));
};
//# sourceMappingURL=PlanFeatures.js.map